<template>
  <div v-if="showComponent">
    <font-awesome-icon
      id="font-awesome-icon-edit"
      icon="edit"
      size="sm"
      class="clickable float-right"
      v-if="showEditButton"
      @click="$emit('edit-button-clicked')"
      />
    <hr/>
  </div>
</template>

<script>
// Utils
import LmCommonProps from '@/mixins/LmCommonProps'

export default {
  mixins: [LmCommonProps],
  props: {
    showEditButton: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped>
hr{
  border-top: 2px solid !important;
}
</style>
